<template>
    <div class="devices">
        <div id="permadeactivateModal" class="confirm modal"  style="width: 50%;">
                <div class="modal-content">
                    <h6>{{questionInact}}</h6>
                <div class="modal-footer row">
                    <div class="col s6">
                        <button class="modal-close waves-effect waves-green btn-small emptygreen" style="width: 100%">{{$t('menu.buttons.cancel')}}</button>
                    </div>
                    <div class="col s6">
                        <button v-on:click="saveZonesDevType(selzone, seldc)" class="modal-close waves-effect waves-green btn-small green" style="width: 100%">{{$t('menu.buttons.change')}}</button>
                    </div>
                </div>
            </div>
        </div>
        <collapsible :title="$t('devices.list')">
            <div class="row">
                <div class="col m2 rightlabel"><span>{{$t('devices.group_by')}}</span></div>
                <div class="col m4">
                    <select v-model="groupby">
                        <option value="dev_category">{{$t('devices.by_device_categories')}}</option>
                        <option value="zone_id">{{$t('devices.by_zones')}}</option>
                    </select>
                </div>
                <div class="col m3 label">
                    <label>
                        <input type="checkbox" v-model="show_inactive" />
                        <span>{{$t('devices.show_inactive')}}</span>
                    </label>
                </div>
            </div>
            <template v-if="loaded == false">
                <div  class="preloader-wrapper big active">
                    <div class="spinner-layer spinner-red-only">
                        <div class="circle-clipper left">
                            <div class="circle"></div>
                        </div>
                        <div class="gap-patch">
                            <div class="circle"></div>
                        </div>
                        <div class="circle-clipper right">
                            <div class="circle"></div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-for="(items, group) in listItems">
                <collapsible :title="nameGroup(group)">
                    <subdevices ref="subdevice" :place="place" :items="items" :dev_types="dev_types" :group="group" :doseslookup="doseslookup" :suggestions="suggestions" :fromsuggestions="fromsuggestions" :loads="suggestions_loaded || (place.editable == false)" :show_inactive="show_inactive"/>
                </collapsible>
            </template>
        </collapsible>
        <!-- nozones -->
        <collapsible :title="$t('devices.no_zone_devices')" v-if="loaded">
            <div class="card grey lighten-1" v-if="place.orders != undefined && (place.orders.length > 0 || newordergroup != undefined || Object.keys(ordergroups).length > 0)">
                <div class="card" v-for="(list, key) in ordergroups" v-if="place.orders != undefined" style="text-align: left;">
                    <template>
                        <div class="row" style="line-height: 3;">
                         <div class="col m7 s5">
                                {{$t('dev_types.device_category')}}: <b>{{nameGroup(key)}}</b>
                            </div>
                              <div class="col m2 s3" v-if="mounted_counts[key] == 0 || mounted_counts[key] == undefined">
                                <a class="btn btn-small red" v-on:click="removeCatGroup(key)" v-if="edit_orders">{{$t('menu.buttons.delete')}}</a>
                            </div>
                        </div>
                        <div class="row" v-if="list != undefined && list.length > 0">
                            <div class="col m4">{{$t('devices.dev_type')}}</div>
                            <div class="col m2 input-field">{{$t('devices.scheduled')}}</div>
                            <div class="col m2 input-field">{{$t('devices.installed')}}</div>
                            <div class="col m3 input-field">{{$t('devices.inspections_frequency')}}</div>
                        </div>
                        <template v-if="list != undefined" v-for="order in list">
                            <div class="row nozones" v-if="!order.destroy">
                                <div class="col m4" v-if="device_categories[key] != undefined">
                                    <select v-model="order.dev_type_id"  :disabled="!edit_orders || counts[order.dev_type_id] > 0"> 
                                        <option 
                                            v-for="devt in device_categories[key].dev_types" 
                                            v-if="mapIt(list, 'dev_type_id').indexOf(devt.id) == -1 || devt.id == order.dev_type_id" 
                                            :value="devt.id"
                                        >{{devt.name}}</option>
                                    </select>
                                </div>
                                <div class="col m2 input-field">
                                    <input type="number" v-model="order.quantity" :disabled="!edit_orders" />
                                </div>
                                <div class="col m2 input-field">
                                    <input v-if="Object.keys(counts).indexOf(order.dev_type_id+'') > -1" v-model="counts[order.dev_type_id]" disabled />
                                    <input v-else value="0" disabled />
                                </div>
                                <div class="col m3 input-field">{{$t('devices.every')}} <input type="number" v-model="order.time_interval_days" style="width: 47px;"  :disabled="!edit_orders">&nbsp;{{$t('devices.days')}}</div>
                                <div class="col m1 input-field" v-if="(counts[order.dev_type_id] == undefined || counts[order.dev_type_id] == 0) && edit_orders">
                                    <a
                                        class="btn btn-small red"
                                        v-on:click="removeOrder(order, key)"
                                        :class="{'mounted': counts[order.dev_type_id] == 0}"
                                    >
                                        {{$t('devices.delete')}}
                                    </a>
                                </div>
                            </div>
                        </template>
                        <div class="row" v-if="edit_orders && intersectIt(mapIt(list, 'dev_type_id'), mapIt(device_categories[key].dev_types, 'id')).length <  mapIt(device_categories[key].dev_types, 'id').length">
                            <div class="col m2 input-field">
                                <a class="btn btn-small green" v-on:click="addOrder(key)">{{$t('devices.add_devices')}}</a>
                            </div>
                        </div>
                    </template>
                </div>
                <div class="card" v-if="newordergroup != undefined" style="text-align: left;">
                    <div class="row" v-if="edit_orders">
                        <div class="col m12">
                            <autosizelabel :text="$t('dev_types.device_category')+':'" /><select v-model="newordergroup.device_category_id" style="width: initial;">
                                <option v-for="devt in device_categories" :value="devt.id"  v-if="Object.keys(ordergroups).indexOf('' + devt.id) == -1">{{devt.name}}</option>
                            </select></div>
                    </div>
                    <div class="row" v-if="edit_orders">
                         <div class="col  m3 offset-m3"><a class="btn btn-large cancelbutton" v-on:click="cancelCatGroup(zone)">{{$t('menu.buttons.cancel_changes')}}</a></div>
                            <div class="col m3"><a class="btn btn-large emptygreen" v-on:click="saveCatGroup()">{{$t('device_categories.add_category')}}</a></div>
                    </div>
                </div>
            </div>
            <div class="row" v-if="edit_orders">
                <div class="col m2 input-field"><a class="btn btn-small green" v-on:click="addCategoryGroup()">{{$t('device_categories.add_category')}}</a></div>
                <div class="col offset-m6 m2"><a class="btn btn-large cancelbutton" v-on:click="cancelOrders()" v-if="edit_orders">{{$t('menu.buttons.cancel')}}</a></div>
                <div class="col m2"><a class="btn btn-large emptygreen" v-on:click="saveOrders()" v-if="edit_orders">
                        <div v-if="saving_devices" class="preloader-wrapper small active">
                            <div class="spinner-layer spinner-red-only">
                                <div class="circle-clipper left">
                                    <div class="circle"></div>
                                </div>
                                <div class="gap-patch">
                                    <div class="circle"></div>
                                </div>
                                <div class="circle-clipper right">
                                    <div class="circle"></div>
                                </div>
                            </div>
                        </div>
                        {{saving_devices == false ? $t('menu.buttons.save') : ""}}
                    </a></div>
            </div>
            <div class="row" v-if="!edit_orders">
                <div class="col m2 input-field"><a class="btn btn-small green" v-on:click="editOrders()" v-if="editable">{{$t('menu.buttons.edit')}}</a></div>
            </div>
        </collapsible>
        <!-- /nozones -->
        <!-- zones -->
        <collapsible :title="$t('devices.zone_devices')" v-if="place.zones != undefined && loaded">
            <template v-for="(zone, group) in place.zones">
                <div class="card grey lighten-1" v-if="!zone.destroy">
                    <div class="row">
                        <div class="col m1" style="line-height: 2">{{$t('devices.zone')}}</div>
                        <div class="col m5 input-field">
                            <input type="text" name="zonename" v-model="zone.name" :disabled="!edit_zones" /> {{zone.destroy}}
                        </div>
                        <div class="col m2" style="line-height: 2;" v-if="!edit_zones">
                            <label>
                                <input type="checkbox" v-model="zone.has_disaster_point" :disabled="true" />
                                <span style="color: black;">{{$t('devices.catastrophal_point')}}</span>
                            </label>
                        </div>
                        <div class="col m2" style="line-height: 2;" v-if="edit_zones">
                            <label>
                                <input type="checkbox" v-model="zone.has_disaster_point"/>
                                <span style="color: black;">{{$t('devices.catastrophal_point')}}</span>
                            </label>
                        </div>
                        <div class="col m1"><a class="btn btn-small  red" v-if="edit_zones" v-on:click="removeZone(zone)">{{$t('menu.buttons.delete')}}</a></div>
                    </div>
                    <!-- device category -->

                    <div class="card" v-for="(list, key) in zone.criteria_groups">
                        <div class="row" style="line-height: 3">
                            <div class="col m7 s5">
                                {{$t('dev_types.device_category')}}: <b>{{nameGroup(key)}}</b>
                            </div>
                              <div class="col m2 s3" v-if="mounted_counts[key+','+zone.id] == 0 || mounted_counts[key+','+zone.id] == undefined">
                                <a class="btn btn-small red" v-on:click="removeZoneDevCategory(zone, key)" v-if="edit_zones">{{$t('menu.buttons.delete')}}</a>
                            </div>
                        </div>
                        <template v-if="zone.criteria_groups[key]">
                            <template  v-if="zone.criteria_groups[key].old">
                                Obowiązuje do {{today}}
                                <zone_criterium
                                    v-if="zone.criteria_groups[key]"
                                    :zone=zone
                                    :criterium=zone.criteria_groups[key].old
                                    :edit_zones='false'
                                    :group="key"
                                    ref="zone_criterium"
                                    :editable="false"
                                    :pests=pests />
                                Obowiązuje od {{tomorrow}}
                            </template>
                            <zone_criterium
                                v-if="zone.criteria_groups[key]"
                                :zone=zone
                                :criterium=zone.criteria_groups[key]
                                :edit_zones='zone.edited_types.indexOf(key) > -1'
                                :group="key"
                                :editable="editable"
                                ref="zone_criterium"
                                :pests=pests />
                        </template>
                        <div class="row" style="line-height: 2" v-if=" zone.order_groups[key] != undefined && zone.order_groups[key].length > 0">
                            <div class="col m4">{{$t('devices.dev_type')}}</div>
                            <div class="col m2 input-field">{{$t('devices.scheduled')}}</div>
                            <div class="col m2 input-field">{{$t('devices.installed')}}</div>
                            <div class="col m3 input-field">{{$t('devices.inspections_frequency')}}</div>
                        </div>
                        <template v-for="order in zone.order_groups[key]">
                            <div class="row" style="line-height: 2" v-if="!order.destroy">
                                <div class="col m4" v-if="device_categories[key] != undefined">
                                    <select v-model="order.dev_type_id" :disabled="zone.edited_types.indexOf(key)  == -1">
                                        <option
                                            v-for="devt in device_categories[key].dev_types"
                                            v-if="mapIt(zone.order_groups[key], 'dev_type_id').indexOf(devt.id) == -1 || devt.id == order.dev_type_id"
                                            :value="devt.id">
                                            {{devt.name}}
                                        </option>
                                    </select>
                                    <p style="color: #C22026;" v-if="order.errors">
                                        {{order.errors.dev_type_id}}
                                    </p>
                                </div>
                                <div class="col m2 input-field">
                                    <input v-model="order.quantity" :disabled="zone.edited_types.indexOf(key) == -1" type="number" />
                                </div>
                                <div class="col m2 input-field">
                                    <input v-if="countszones[order.dev_type_id+','+zone.id] == undefined" value="0" disabled type="number" />
                                    <input v-else v-model="countszones[order.dev_type_id+','+zone.id]" disabled type="number" />
                                </div>
                                <div class="col m3 input-field">{{$t('devices.every')}} <input v-model="order.time_interval_days" style="width: 47px;" :disabled="zone.edited_types.indexOf(key) == -1" type="number" />&nbsp;{{$t('devices.days')}}</div>
                                <div class="col m1 input-field"><a class="btn btn-small red" v-on:click="removeOrderFromZone(zone, order, key)" v-if="zone.edited_types.indexOf(key)  != -1">{{$t('menu.buttons.delete')}}</a></div>
                            </div>
                        </template>
                        <div class="row" style="margin-top: 15px;" v-if="(zone.edited_types.indexOf(key)  != -1 || zone.id == null) && intersectIt(mapIt(zone.order_groups[key], 'dev_type_id'), mapIt(device_categories[key].dev_types, 'id')).length <  mapIt(device_categories[key].dev_types, 'id').length">
                            <div class="col m2 input-field"><a class="btn btn-small green" v-on:click="addOrderToZone(zone, key)">{{$t('devices.add_devices')}}</a></div>
                        </div>
                        <div class="row" v-if="zone.id != undefined" style="padding-top: 5px;">
                            <div class="col offset-m9 m3"><a class="btn btn-large emptygreen" v-on:click="zonesDevTypeEdit(zone, key)" v-if="zone.edited_types.indexOf(key)  == -1">{{$t('menu.buttons.edit')}}</a></div>
                            <div class="col offset-m6 m3"><a class="btn btn-large cancelbutton" v-on:click="cancelZonesDevTypeEdit(zone, key)" v-if="zone.edited_types.indexOf(key)  != -1">{{$t('menu.buttons.cancel')}}</a></div>
                            <div class="col m3"><a class="btn btn-large emptygreen" v-on:click="changeOrdersAsk(zone, key)" v-if="zone.edited_types.indexOf(key)  != -1">
                                    <div v-if="zone.saving_types.indexOf(key) != -1" class="preloader-wrapper small active">
                                        <div class="spinner-layer spinner-red-only">
                                            <div class="circle-clipper left">
                                                <div class="circle"></div>
                                            </div>
                                            <div class="gap-patch">
                                                <div class="circle"></div>
                                            </div>
                                            <div class="circle-clipper right">
                                                <div class="circle"></div>
                                            </div>
                                        </div>
                                    </div>
                                    {{zone.saving_types.indexOf(key) == -1 ? $t('menu.buttons.save') : ""}}
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="card" v-if="zone.newordergroup != undefined" style="text-align: left;">
                        <div class="row">
                            <div class="col m10 s8 ">
                                <autosizelabel :text="$t('dev_types.device_category')+':'" /><select v-model="zone.newordergroup.device_category_id" style="width: initial;">
                                    <option v-for="devt in device_categories" :value="devt.id" v-if="Object.keys(zone.order_groups).indexOf('' + devt.id) == -1">{{devt.name}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col  m3 offset-m3"><a class="btn btn-large cancelbutton" v-on:click="cancelZoneCatGroup(zone)">{{$t('menu.buttons.cancel_changes')}}</a></div>
                            <div class="col m3"><a class="btn btn-large emptygreen" v-on:click="saveZoneCatGroup(zone)">{{$t('device_categories.add_category')}}</a></div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col m3 input-field"><a class="btn btn-small green" v-on:click="addCategoryGroupToZone(zone)">{{$t('device_categories.add_category')}}</a>
                        </div>
                    </div>
                    <!-- /device category -->
                </div>
            </template>
            <div class="row">
                <div class="col m3"><a class="btn btn-small green" v-on:click="addZone()">Dodaj strefę</a></div>
            </div>
            <div class="row">
                <div class="col offset-m9 m3"><a class="btn btn-large emptygreen" v-on:click="zonesEdit()" v-if="!edit_zones && place.zones.length > 0">{{$t('menu.buttons.edit')}}</a></div>
                <div class="col offset-m6 m3"><a class="btn btn-large cancelbutton" v-on:click="cancelEditZones()" v-if="edit_zones">{{$t('menu.buttons.cancel')}}</a></div>
                <div class="col m3"><a class="btn btn-large emptygreen" v-on:click="saveZones()" v-if="edit_zones">
                        <div v-if="saving_devices" class="preloader-wrapper small active">
                            <div class="spinner-layer spinner-red-only">
                                <div class="circle-clipper left">
                                    <div class="circle"></div>
                                </div>
                                <div class="gap-patch">
                                    <div class="circle"></div>
                                </div>
                                <div class="circle-clipper right">
                                    <div class="circle"></div>
                                </div>
                            </div>
                        </div>
                        {{saving_devices == false ? $t('menu.buttons.save') : ""}}
                    </a></div>
            </div>
        </collapsible>
         <!-- /zones -->
    </div>
</template>
<script>
import axios from 'axios';
import moment from 'moment';
export default {
    data: function() {
        return {
            devices: [],
            selections: [],
            pests: [],
            checkedDevices: [],
            dev_types: {},
            counts: {},
            saving_devices: false,
            device_categories: {},
            suggestions: { changes: [], deactivates: [], temporary_inactivate: [] },
            ordergroups: {},
            countszones: {},
            newordergroup: undefined,
            groupby: 'dev_category',
            show_inactive: false,
            edit_devices: false,
            edit_orders: false,
            edit_zones: false,
            suggestions_loaded: false,
            cause: "",
            mounted_counts: {},
            selectedoptions: {},
            questionInact: "",
            doseslookup: {},
            today: moment().format("DD MMMM YYYY"),
            tomorrow: moment().add(1,'days').format("DD MMMM YYYY"),
            tochangenumbers: [],
            todeactivenumbers: [],
            totempdeactivate: [],
            fromsuggestions: {}
        }
    },
    created() {
        // fetch the data when the view is created and the data is
        // already being observed
        this.fetchData()

    },
    mounted() {
        var elems = document.querySelectorAll('.dropdown-trigger');
        var instances = M.Dropdown.init(elems, {});
    },
    watch: {},
    props: {
        place: { documents: [] },
        editable: Boolean
    },
    methods: {
        nameGroup(id) {
            if (this.groupby == 'dev_category') {
                if (_.isUndefined(this.device_categories[id])) return ""
                else return this.device_categories[id].name
            } else if (id == "null") {
                return "Brak strefy"
            } else if(this.place.zones_groups[id] == undefined){
                return ""
            } else {
                return this.place.zones_groups[id].name
            }
        },
      
        fetchData: async function() {
            var that = this;
            this.loaded = false;
            if (this.place_id != 0 && this.$route.params.place_id != 'new') {
                var response = await axios.get('/device_categories.json')
                that.devcats = response.data
                that.device_categories = {};
                that.dev_types = {};
                for (var i = that.devcats.length - 1; i >= 0; i--) {
                    that.device_categories[that.devcats[i].id] = that.devcats[i];
                    for (var j = that.devcats[i].dev_types.length - 1; j >= 0; j--) {
                        var dt = that.devcats[i].dev_types[j];
                        dt.device_category_id = that.devcats[i].id;
                        that.dev_types[dt.id] = dt
                    }
                }
                response = await axios.get('/customers/' + this.$route.params.customer_id + '/places/' + this.$route.params.place_id + '/dosages.json')
                for(var index in response.data){
                    for(var devid in response.data[index]['device_ids']){
                        if(this.doseslookup[response.data[index]['device_ids'][devid]] == undefined){
                            this.doseslookup[response.data[index]['device_ids'][devid]] = []
                        }
                         this.doseslookup[response.data[index]['device_ids'][devid]].push(response.data[index]);
                    }
                }
                response = await axios.get('/customers/' + this.$route.params.customer_id + '/places/' + this.$route.params.place_id + '/devices.json')
                that.devices = _.filter(response.data, function(device){return device.permanently_removed == false});
                this.counts = {}
                for (var i = 0; i != that.devices.length; i++) {
                    var dev = that.devices[i];
                    if (_.isUndefined(this.countszones[dev.dev_type_id + "," + dev.zone_id])) {
                        this.countszones[dev.dev_type_id + "," + dev.zone_id] = 0
                    }
                    if (_.isUndefined(this.mounted_counts[dev.device_category_id])) {
                        this.mounted_counts[dev.device_category_id] = 0
                    }
                    if (_.isUndefined(this.mounted_counts[dev.dev_category + "," + dev.zone_id])) {
                        this.mounted_counts[dev.dev_category + "," + dev.zone_id] = 0
                    }
                    if (_.isUndefined(this.counts[dev.dev_type_id])) {
                        this.counts[dev.dev_type_id] = 0
                    }


                    if (dev.active) {
                        if (_.isNull(dev.zone_id)) {
                            if (_.isUndefined(_.find(that.place.orders, { dev_type_id: dev.dev_type_id }))) {
                                that.place.orders.push({ 
                                    time_interval: (30 * 86400000),
                                    quantity: 0,
                                    dev_type_id: dev.dev_type_id,
                                    time_interval_days: 30 
                                })
                            }
                            this.counts[dev.dev_type_id] += 1
                            this.mounted_counts[dev.dev_category] += 1
                        } else {
                            var zone = _.find(that.place.zones, { id: dev.zone_id });
                            if (_.isUndefined(zone) == false) {
                                var order = _.find(zone.orders, { dev_type_id: dev.dev_type_id });
                                if(_.isUndefined(order)){
                                    var order = { 
                                        time_interval: (30 * 86400000),
                                        quantity: 0,
                                        dev_type_id: dev.dev_type_id,
                                        device_category_id: dev.dev_category,
                                        time_interval_days: 30 
                                    }
                                    if(_.isUndefined(zone.order_groups[dev.dev_category])){
                                        zone.order_groups[dev.dev_category] = [];
                                    }
                                    zone.order_groups[dev.dev_category].push(order)
                                    zone.orders.push(order)
                                }
                            }
                            this.countszones[dev.dev_type_id + "," + dev.zone_id] += 1
                            this.mounted_counts[dev.dev_category + "," + dev.zone_id] += 1
                        }
                    }
                }
                this.calcOrders();
              
                that.loaded = true;
                axios.get('/pests.json').then(response => {
                    that.pests = response.data
                    that.loaded = true
                })
                if(this.editable){
                    that.suggestions_loaded = false;
                    var responseSuggestions = await axios.get('/customers/' + this.$route.params.customer_id + '/places/' + this.$route.params.place_id + '/devices/change_suggestions.json');
                    that.suggestions = responseSuggestions.data;
                    if(that.suggestions.changes.length > 0){
                        var devlookup = _.keyBy(that.devices, 'id');
                        for(var j = 0; j != that.suggestions.changes.length; j++){
                            var suggestion = that.suggestions.changes[j];
                            that.fromsuggestions[suggestion.device_id] = suggestion;
                        }
                    }
                    if(that.suggestions.deactivates.length > 0){
                        var devlookup = _.keyBy(that.devices, 'id');
                        for(var j = 0; j != that.suggestions.deactivates.length; j++){
                            var suggestion = that.suggestions.deactivates[j];
                            that.fromsuggestions[suggestion] = {'active': false};
                        }
                    }
                    if(that.suggestions.temporary_inactivate.length > 0){
                        var devlookup = _.keyBy(that.devices, 'id');
                        for(var j = 0; j != that.suggestions.temporary_inactivate.length; j++){
                            var suggestion = that.suggestions.temporary_inactivate[j];
                            that.fromsuggestions[suggestion.device_id] = {'active': false, 'temporary_inactive_cause': suggestion.inactivate_cause};
                        }
                    }
                    console.log(that.fromsuggestions);
                    that.suggestions_loaded = true;
                }
            }
        },
        anyEdited: function(){
            for (var i = this.place.zones.length - 1; i >= 0; i--) {
                if(this.place.zones[i].edited_types.length > 0){
                    return true;
                }
            }
            var devgrpsedited =  _.some(_.map(this.$refs.subdevice, function(subdev){ return subdev.edit_devices; }));
            console.log(devgrpsedited);
            return this.edit_zones || devgrpsedited;
        },
        calcOrders(){
            this.ordergroups = {};
            for (var i = 0; i != this.place.orders.length; i++) {
                var order = this.place.orders[i];
                if (_.isUndefined(this.ordergroups[this.dev_types[order.dev_type_id].device_category_id])) {
                    this.ordergroups[this.dev_types[order.dev_type_id].device_category_id] = []
                }
                this.ordergroups[this.dev_types[order.dev_type_id].device_category_id].push(order)
            }
            for(var j = 0; j != this.place.zones.length; j++){
                var zone = this.place.zones[j];   
            }
        },
        nameZone(device) {
            if (device.zone_id == "null" || device.zone_id == null) {
                return "-"
            } else {
                return this.place.zones_groups[device.zone_id].name;
            }
        },
        cancel() {
            this.edit = false;
        },
        cancelEditZones() {
            this.place.zones = _.cloneDeep(this.old_zones);
            this.edit_zones = false;
        },
        zonesEdit() {
            this.old_zones = _.cloneDeep(this.place.zones);
            this.edit_zones = true;
        },
        addZone() {
            this.zonesEdit();
            this.place.zones.push({ name: '', orders: [], criteria_groups: {}, order_groups: {}, edited_types: [], saving_types: [] })
        },
        devTypeIds(items) {
            return _.uniq(_.map(items, 'dev_type_id'))
        },
        zoneIds(items) {
            return _.uniq(_.map(items, 'dev_type_id'))
        },
        addOrder(key) {
            var firstfree = _.first(_.difference(this.mapIt(this.device_categories[key].dev_types, 'id'), this.mapIt(this.ordergroups[key], 'dev_type_id')))
            var order = { time_interval: (30 * 86400000), quantity: 1, dev_type_id: firstfree };
            Object.defineProperty(order, 'time_interval_days', {
                set: function(x) {
                    this.time_interval = x * 86400000;
                },
                get: function() {
                    return this.time_interval / 86400000;
                }
            });
            this.place.orders.push(order)
            this.ordergroups[key].push(order)
        },
        addCategoryGroup() {
            this.newordergroup = {};
        },
        addCategoryGroupToZone(zone) {
            zone.newordergroup = {};
             this.$forceUpdate();
        },
        changeOrdersAsk(zone, dc) {
            if(!_.isUndefined(this.$refs.zone_criterium)){
                var touched_things = this.$refs.zone_criterium.filter(function(params) {
                    return params.touched && params.group == dc;
                })
                if(touched_things.length > 0){
                    this.questionInact =  this.$t('devices.save_criteria_disclaimer') + " " + moment().add(1,'days').format("DD MMMM YYYY");
                    this.selzone = zone;
                    this.seldc = dc;
                    var elems = document.querySelectorAll('.confirm.modal');
                    this.instances = M.Modal.init(elems, {});
                    this.instances[0].open()
                }else{
                    this.saveZonesDevType(zone, dc)
                }
            }
        },
        inactivate(device) {
            device.active = false;
            this.instances[0].close()
        },
        permaDelete(device) {
            if (confirm(this.$t('devices.remove_question') + " " + device.number + "?")) {
                device.deleted_permanently = true;
            }

        },
        editDevices() {
            this.edit_devices = true;
            this.old_devices = _.cloneDeep(this.devices);
            for (var i = this.$refs.subdevice.length - 1; i >= 0; i--) {
                this.$refs.subdevice[i].edit_devices = true;
            }
            console.log(this.$refs.subdevice)
        },
        cancelEditDevices() {
            this.edit_devices = false;
            this.devices = _.cloneDeep(this.old_devices);
        },
        addOrderToZone(zone, devcid, dev_type_id=null) {
            var firstfree = dev_type_id;
            if(dev_type_id == null){
                var firstfree = _.first(_.difference(this.mapIt(this.device_categories[devcid].dev_types, 'id'), this.mapIt(zone.order_groups[devcid], 'dev_type_id')))
            }
            var order = { time_interval: (30 * 86400000), quantity: 1, device_category_id: devcid, dev_type_id: firstfree };
            Object.defineProperty(order, 'time_interval_days', {
                set: function(x) {
                    this.time_interval = x * 86400000;
                },
                get: function() {
                    return this.time_interval / 86400000;
                }
            });
            if (_.isUndefined(zone.order_groups[devcid])) {
                zone.order_groups[devcid] = [];
                this.zonesDevTypeEdit(zone, devcid)
            }
            var criterion = zone.criteria_groups[devcid]; 
            if (_.isUndefined(criterion)) {
                criterion = _.cloneDeep(_.keyBy(this.device_categories, 'id')[devcid].criterium)

            }
            criterion.id = undefined
            if (_.isUndefined(criterion.method) || _.isNull(criterion.method)) criterion.method = 'standard';
            if (_.isUndefined(criterion.critical_point) || _.isNull(criterion.critical_point)) criterion.critical_point = 2.0;
            if (_.isUndefined(criterion.calculation_method) || _.isNull(criterion.calculation_method)) criterion.calculation_method = 'aver';
            zone.criteria_groups[devcid] = criterion;
            zone.order_groups[devcid].push(order);
            zone.orders.push(order);

            this.$forceUpdate();
        },
        editOrders() {
            this.edit_orders = true;
            this.old_orders = _.cloneDeep(this.place.orders)
            this.$forceUpdate();
        },
        cancelOrders(){
            this.place.orders = _.cloneDeep(this.old_orders)
            this.calcOrders();
            this.edit_orders = false;
            this.newordergroup = undefined;
            this.$forceUpdate();
        },
        async saveOrders(){
            var that = this;
            var orders = { orders_attributes: [] }
            var valid = true;
            for (var i in this.place.orders) {
                var order = this.place.orders[i];
                var orderc = {
                    id: order.id,
                    dev_type_id: order.dev_type_id,
                    quantity: order.quantity,
                    time_interval: order.time_interval
                }
                if (order.destroy) {
                    orderc._destroy = true
                }
                for (var dt in this.orders) {
                    var order = zone.orders[dt];
                    order.errors = {}
                    if (order.dev_type_id == undefined) {
                        order.errors.dev_type_id = this.$t('devices.errors.no_devtype')
                        this.ordergroups[this.ordergroups.indexOf(order)].errors.dev_type_id = this.$t('devices.errors.no_devtype')
                        valid = false;
                    }
                }
                orders.orders_attributes.push(orderc)
            }
            this.$forceUpdate();

            if (valid) {
                this.saving_devices = true;
                await axios.put('/customers/' + this.$route.params.customer_id + '/places/' + this.$route.params.place_id + '.json', { place: orders })
                this.saving_devices = false;
                this.edit_orders = false;
            }
        },
        addTargetPest(crit, devcid) {
            if (_.isUndefined(crit.pests_thresolds)) {
                crit.pests_thresolds = [];
            }
            crit.pests_thresolds.push({
                pest_id: 0,
                group_id: 0,
                medium_activity_thresold: crit.medium_activity_thresold,
                high_activity_thresold: crit.high_activity_thresold,
                very_high_activity_thresold: crit.very_high_activity_thresold,
                critical_point: crit.critical_point,
                disaster_point: crit.disaster_point
            })
            this.$forceUpdate();
        },
        removeTargetPest(crit, tp) {
            if (tp.id != undefined) {
                tp.destroy = true;
            } else {
                crit.pests_thresolds.splice(crit.pests_thresolds.indexOf(tp), 1)
            }
            this.$forceUpdate();
        },
        removeOrderFromZone(zone, order, devcid) {
            if (_.isUndefined(order.id) == false) {
                order.destroy = true;
            } else {
                zone.order_groups[devcid].splice(zone.order_groups[devcid].indexOf(order), 1)
                zone.orders.splice(zone.orders.indexOf(order), 1)
            }
            this.$forceUpdate();

        },
        removeOrder(order, key) {
            if (order.id) order.destroy = true;
            else {
                this.place.orders.splice(this.place.orders.indexOf(order), 1)
                this.ordergroups[key].splice(this.ordergroups[key].indexOf(order), 1)
            }
            this.$forceUpdate();

        },
        selectItems(active, zone, dev_type, group) {
            this.checkedDevices = []
            for (var dev in this.devices) {
                if (this.groupby == "zone") {
                    if (active != null && this.devices[dev].active == active && this.devices[dev].zone_id == parseInt(group)) {
                        this.checkedDevices.push(this.devices[dev].id);
                    }
                    if (zone != null && this.devices[dev].zone_id == zone && this.devices[dev].zone_id == parseInt(group)) {
                        this.checkedDevices.push(this.devices[dev].id);
                    }
                    if (dev_type != null && this.devices[dev].dev_type_id == dev_type && this.devices[dev].zone_id == parseInt(group)) {
                        this.checkedDevices.push(this.devices[dev].id);
                    }
                }
                if (this.groupby == "dev_category") {
                    if (active != null && this.devices[dev].active == active && this.devices[dev].dev_category == parseInt(group)) {
                        this.checkedDevices.push(this.devices[dev].id);
                    }
                    if (zone != null && this.devices[dev].zone_id == zone && this.devices[dev].dev_category == parseInt(group)) {
                        this.checkedDevices.push(this.devices[dev].id);
                    }
                    if (dev_type != null && this.devices[dev].dev_type_id == dev_type && this.devices[dev].dev_category == parseInt(group)) {
                        this.checkedDevices.push(this.devices[dev].id);
                    }
                }
            }
        },
        changeTo(active, zone, dev_type, group) {
            for (var dev in this.devices) {
                if (this.groupby == "zone") {
                    if (active != null && this.checkedDevices.indexOf(this.devices[dev].id) > -1) {
                        this.devices[dev].active = active;
                    }
                    if (zone != null && this.checkedDevices.indexOf(this.devices[dev].id) > -1) {
                        this.devices[dev].zone_id = zone;
                    }
                    if (dev_type != null && this.checkedDevices.indexOf(this.devices[dev].id) > -1) {
                        this.devices[dev].dev_type_id = dev_type;
                    }
                }
                if (this.groupby == "dev_category") {
                    if (active != null && this.checkedDevices.indexOf(this.devices[dev].id) > -1) {
                        this.devices[dev].active = active;
                    }
                    if (zone != null && this.checkedDevices.indexOf(this.devices[dev].id) > -1) {
                        this.devices[dev].zone_id = zone;
                    }
                    if (dev_type != null && this.checkedDevices.indexOf(this.devices[dev].id) > -1) {
                        this.devices[dev].dev_type_id = dev_type;
                    }
                }
            }
        },
        removeZone(zone) {
            if (zone.id == undefined) {
                this.place.zones.splice(this.place.zones.indexOf(zone), 1)
            } else {
                zone.destroy = true;
                this.$forceUpdate();
            }
        },
        zonesDevTypeEdit(zone, dc) {
            zone.olddc = _.cloneDeep(zone.criteria_groups[dc])
            zone.oldorders = _.cloneDeep(zone.order_groups[dc])
            zone.edited_types.push(dc)
            this.$forceUpdate();
        },
        cancelZonesDevTypeEdit(zone, dc) {
            zone.criteria_groups[dc] = _.cloneDeep(zone.olddc)
            zone.order_groups[dc] = _.cloneDeep(zone.oldorders)
            zone.edited_types.splice(zone.edited_types.indexOf(dc), 1)
            this.$refs.zone_criterium.filter(function(params) {
                return params.touched && params.group == dc;
            }).map(function(param){
                return param.touched = false;
            });
            this.$forceUpdate();
        },
        removeZoneDevCategory(zone, dc){
            for (var i = zone.order_groups[dc].length - 1; i >= 0; i--) {
                 this.removeOrder(zone.order_groups[dc][i], dc);
            }
            delete zone.order_groups[dc]
            delete zone.criteria_groups[dc]
            this.$forceUpdate();
        },
        cancelCatGroup(){
            this.newordergroup = undefined;
            this.$forceUpdate();
        },
        saveCatGroup() {
            this.ordergroups[this.newordergroup.device_category_id] = []
            this.newordergroup = undefined
        },
        removeCatGroup(dc){
            for (var i = this.ordergroups[dc].length - 1; i >= 0; i--) {
                 this.removeOrder(this.ordergroups[dc][i], dc);
            }
            delete this.ordergroups[dc]
            this.$forceUpdate();
        },
        cancelZoneCatGroup(zone) {
            zone.newordergroup = undefined;
            this.$forceUpdate();
        },
        saveZoneCatGroup(zone) {
            zone.order_groups[zone.newordergroup.device_category_id] = [];
            zone.criteria_groups[zone.newordergroup.device_category_id] = _.cloneDeep(_.keyBy(this.device_categories, 'id')[zone.newordergroup.device_category_id].criterium)
            zone.edited_types.push(""+zone.newordergroup.device_category_id);
            zone.newordergroup = undefined;
            this.$forceUpdate();
        },
        async saveZonesDevType(zone, dc) {
            if(zone.saving_types.indexOf(dc) == -1 ){
            var cg = zone.criteria_groups[dc]
            var valid = true;
            for (var dt in zone.order_groups[dc]) {
                var order = zone.order_groups[dc][dt];
                order.errors = {}
                if (order.dev_type_id == undefined) {
                    order.errors.dev_type_id = this.$t('devices.errors.no_devtype')
                    zone.orders[zone.orders.indexOf(order)].errors.dev_type_id = this.$t('devices.errors.no_devtype')
                    valid = false;
                }
                if(order.destroy) order._destroy = true;
            }
        
            var params = {
                place: {
                    zones_attributes: [{
                        id: zone.id,
                        has_disaster_point: zone.has_disaster_point,
                        name: zone.name,
                        orders_attributes: zone.order_groups[dc],
                        zone_device_categories_attributes: [{
                                id: cg._id,
                                device_category_id: dc,
                                criterium_attributes: {
                                    id: cg.criterium_id,
                                    method: cg.method,
                                    calculation_method: cg.calculation_method,
                                    critical_point: cg.critical_point,
                                    disaster_point: cg.disaster_point,
                                    critical_calculation: cg.critical_calculation,
                                    no_activity_text: cg.no_activity_text,
                                    low_activity_text: cg.low_activity_text,
                                    medium_activity_text: cg.medium_activity_text,
                                    high_activity_text: cg.high_activity_text,
                                    very_high_activity_text: cg.very_high_activity_text,
                                    no_activity_thresold: cg.no_activity_thresold,
                                    low_activity_thresold: cg.low_activity_thresold,
                                    medium_activity_thresold: cg.medium_activity_thresold,
                                    high_activity_thresold: cg.high_activity_thresold,
                                    very_high_activity_thresold: cg.very_high_activity_thresold,
                                    pest_thresolds_attributes: cg.pests_thresolds
                                },

                            }

                        ]
                    }]
                }
            }

            if (valid) {
                zone.saving_types.push(dc)
                try{
                    var response = await axios.put(
                        '/customers/' + this.$route.params.customer_id + '/places/' + this.$route.params.place_id + '.json',
                        params
                    )
                }catch (err) {

                }
                var newzone = _.find(response.data.zones, {id: zone.id});
                var oldzone = _.find(this.place.zones, {id: zone.id});
                _.assign(zone, oldzone)
                for (var dt in zone.orders) {
                    var order = zone.orders[dt];
                    order.errors = {}
                    if (order.dev_type_id == undefined) {
                        order.errors.dev_type_id = this.$t('devices.errors.no_devtype')
                        zone.orders[zone.orders.indexOf(order)].errors.dev_type_id = this.$t('devices.errors.no_devtype')
                        valid = false;
                    }
                }
                zone.edited_types.splice(zone.edited_types.indexOf(dc), 1)
                zone.saving_types.splice(zone.saving_types.indexOf(dc), 1)
            }
            this.$forceUpdate();
        }
        },
        async saveZones() {
            var that = this;
            var zones = { zones_attributes: [] }
            var valid = true;
            for (var i in this.place.zones) {
                var zone = this.place.zones[i];
                var zz = {
                    id: zone.id,
                    name: zone.name,
                    has_disaster_point: zone.has_disaster_point
                }
                if (zone.destroy) {
                    zz._destroy = true
                }
                if (zone.id == undefined) {
                    zz.zone_device_categories_attributes = []
                }
                for (var dt in zone.criteria_groups) {
                    var criterium = zone.criteria_groups[dt];
                    criterium.device_category_id = dt;
                    if (zone.id == undefined) {
                        zz.zone_device_categories_attributes.push({
                            device_category_id: dt,
                            criterium_attributes: {
                                method: criterium.method,
                                calculation_method: criterium.calculation_method,
                                critical_calculation: criterium.critical_calculation,
                                no_activity_text: criterium.no_activity_text,
                                low_activity_text: criterium.low_activity_text,
                                medium_activity_text: criterium.medium_activity_text,
                                high_activity_text: criterium.high_activity_text,
                                very_high_activity_text: criterium.very_high_activity_text,
                                no_activity_thresold: criterium.no_activity_thresold,
                                low_activity_thresold: criterium.low_activity_thresold,
                                medium_activity_thresold: criterium.medium_activity_thresold,
                                high_activity_thresold: criterium.high_activity_thresold,
                                pest_thresolds_attributes: criterium.pests_thresolds
                            },

                        })
                    }

                    criterium.errors = {}
                    if (criterium.method == undefined) {
                        zone.criteria_groups[dt].errors.method = this.$t('devices.errors.no_measure_method')
                        valid = false;
                    }
                }
                for (var dt in zone.orders) {
                    var order = zone.orders[dt];
                    order.errors = {}
                    if (order.dev_type_id == undefined) {
                        order.errors.dev_type_id = this.$t('devices.errors.no_devtype')
                        zone.orders[zone.orders.indexOf(order)].errors.dev_type_id = this.$t('devices.errors.no_devtype')
                        valid = false;
                    }
                }
                zones.zones_attributes.push(zz)
            }
            this.$forceUpdate();

            if (valid) {
                this.saving_devices = true;
                try {
                    var resp = await axios.put('/customers/' + this.$route.params.customer_id + '/places/' + this.$route.params.place_id + '.json', { place: zones })
                    this.place.zones = resp.data.zones
                    this.place.zones_groups = _.keyBy(this.place.zones, 'id')
                    for (var zone of this.place.zones) {
                        zone.edited_types = []
                        zone.saving_types = []
                        for (var order of zone.orders) {
                            order.destroy = false
                            Object.defineProperty(order, 'time_interval_days', {
                                set: function(x) {
                                    this.time_interval = x * 86400000;
                                },
                                get: function() {
                                    return this.time_interval / 86400000;
                                }
                            });
                        }
                        zone.order_groups = _.groupBy(zone.orders, 'device_category_id')
                        zone.criteria_groups = _.keyBy(zone.criteria, 'device_category_id')
                    }
                }catch (err) {

                }
                this.saving_devices = false;
                this.edit = false;
            }

        },
        onChange() {
            this.$forceUpdate();
        },
        mapIt(dt, name){
            return _.map(dt, name);
        },
        intersectIt(a,b){
           return _.intersection(a, b);
        }
    },
    computed: {
        listItems() {
            var that = this;
            return _.groupBy(_.orderBy(this.devices, 'dev_num'), this.groupby);
        }
    }
}
</script>
<style scoped>
.collapsible-body {
    border-bottom: 0px !important;
}

.row {
    text-align: left;
}

/deep/ select {
    display: block;
    background-color: white !important;
    border-radius: 4px !important;
    border-width: 1px !important;
    border-style: solid !important;
    border-color: rgb(140, 140, 140) !important;
    padding-left: 5px !important;
    height: 35px !important;
}

/deep/ select:disabled {
    color: rgba(0, 0, 0);
}

.modal {
    width: 50%;
}

.modal div {
    width: 100%;
}

.input-field {
    margin-top: 5px;
    margin-bottom: 5px;
}

.card {
    width: 100%;
    padding: 15px;
}

.card .row {
    margin-bottom: 0px
}

.nozones,
.card .input-field {
    margin: 0px
}

.collapsible-header i {
    position: absolute;
    right: 2% !important;
}
/deep/ .collapsible-body .collapsible-header i {
    position: absolute;
    right: 8% !important;
}
.tabel {
    line-height: 2;
}

.red {
    background-color: #C22026 !important;
    border-color: #C22026 !important;
}

.btn-small {
    color: black;
    border-radius: 8px;
}

b {
    font-weight: bold !important;
}

.text-bold {
    font-weight: 700;
}

.header>.text-bold {
    line-height: 3;
}

.label {
    line-height: 2;
}

ul.dropdown-content li {}

/deep/ .collapsible-body {
    padding-top: 1rem;
    padding-bottom: 1rem;
}

.dropdown-trigger {
    padding: 3px;
    border-radius: 4px !important;
    border-width: 1px !important;
    border-style: solid !important;
    border-color: rgb(140, 140, 140) !important;
}

.btn-large /deep/ {
    border-radius: 8px;
    background-color: white;
    color: black;
    border-color: #00CC66;
    border-width: 1px;
    border-style: solid;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>